import { Module } from "vuex";
import { RootState } from "../types";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { LoginState } from "./types";

export const state: LoginState = {
  user: undefined,
  error: false,
  isLogged: false,
  sites: [],
  enseignes: [],
  sirets: [],
  token: "",
  groupements: [],
  loading: true,
  language: "",
};

const namespaced: boolean = true;

export const login: Module<LoginState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
